var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03WmdrUnlocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3497_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 16C14.5267 16 13.3333 17.1933 13.3333 18.6667C13.3333 20.14 14.5267 21.3333 16 21.3333C17.4733 21.3333 18.6667 20.14 18.6667 18.6667C18.6667 17.1933 17.4733 16 16 16Z",
    fill: "#FFC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3147 5.35192L21.4213 5.24525C21.9213 4.74525 21.9227 3.91859 21.4013 3.43992C19.9787 2.13325 18.084 1.33325 16 1.33325C11.5813 1.33325 8 4.91459 8 9.33325H10.6667C10.6667 6.38792 13.0547 3.99992 16 3.99992C17.36 3.99992 18.5987 4.51192 19.5387 5.35059C20.056 5.81192 20.824 5.84259 21.3147 5.35192Z",
    fill: "#FFC020"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M28 20.7399V13.3333C28 11.1239 26.2093 9.33325 24 9.33325H8C5.79067 9.33325 4 11.1239 4 13.3333V23.9999C4 26.2093 5.79067 27.9999 8 27.9999H20.74C21.664 29.5879 23.364 30.6666 25.3333 30.6666C28.2787 30.6666 30.6667 28.2786 30.6667 25.3333C30.6667 23.3639 29.588 21.6639 28 20.7399Z",
    fill: "#FFC020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3333 18.6667C21.652 18.6667 18.6667 21.6521 18.6667 25.3334C18.6667 29.0147 21.652 32.0001 25.3333 32.0001C29.0147 32.0001 32 29.0147 32 25.3334C32 21.6521 29.0147 18.6667 25.3333 18.6667ZM28.8253 24.8254L25.492 28.1587C25.272 28.3787 24.9787 28.5001 24.6667 28.5001C24.3547 28.5001 24.0613 28.3787 23.8413 28.1587L21.8413 26.1587C21.3867 25.7027 21.3867 24.9641 21.8413 24.5081C22.296 24.0547 23.036 24.0547 23.4907 24.5081L24.6653 25.6841L27.1733 23.1747C27.628 22.7214 28.368 22.7214 28.8227 23.1747C29.28 23.6307 29.28 24.3694 28.8253 24.8254Z",
    fill: "#FFC020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3497_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03WmdrUnlocked);
export default __webpack_public_path__ + "static/media/03_wmdr_unlocked.d3e8b5dc5ce0147806a1d7d848086067.svg";
export { ForwardRef as ReactComponent };